import React from "react";

function Header({ actTabHeader, customTitle }) {
  const title = customTitle || "Credential, Registry and Data Tokenization";
  
  return (
    <div className="d-flex w-100 flex-row justify-content-between align-middle align-items-center">
      <img className="p-3 " src="/Vector-5.png" alt="Logo" />
      <div className="flex-grow-1 text-center">
        <h1 className="mainheader">{title}</h1>
      </div>
      <div>
        <ul className="d-flex justify-content-center align-items-center m-0 documentation-links p-0">
          <li>
            <a href="https://github.com/dhiway/cord.js" className="d-flex align-items-center" target="_blank">
              <i className="fab fa-github pr-3" style={{ marginRight: "10px" }}></i> Github
            </a>
          </li>
          <li>
            <a
              href="https://issuer-agent.demo.dhiway.com/docs/"
              className="d-flex align-items-center"
              target="_blank"
            >
              <i className="fas fa-book pr-2" style={{ marginRight: "10px" }}></i> Documentation
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Header;
